import KeyValuePair from "@/modules/core/support/KeyValuePair";
import moment from "moment";

export interface GuideRef {
    id: number
    title: string
}

export interface UserRef {
    id: number
    name: string
    email: string
}

/**
 * Representa una visualización o visita de un usuario a una guía
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class GuideView {
    public id = 0

    /**
     * Fecha y hora de la visita del usuario a la guía
     */
    public datetime = new Date()

    /**
     * Usuario que ha visitado la guía
     */
    public user: UserRef = {
        id: 0,
        email: '',
        name: ''
    }

    /**
     * Guía visitada por el usuario
     */
    public guide: GuideRef = {
        id: 0,
        title: '',
    }

    /**
     * Crea una entidad a partir de los datos obtenidos en JSON
     *
     * @param data
     */
    public static deserialize(data: KeyValuePair) {
        const view = new this()
        view.id = data.id
        view.guide = data.guide
        view.user = data.user
        view.datetime = moment(data.datetime, 'DD-MM-YYYY HH:mm:ss').toDate()

        return view
    }
}
